import type { FC, SVGProps } from "react";

const IconSpaAccess: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M6.19922 13.8C6.72965 13.8 7.23836 14.0108 7.61343 14.3858C7.98851 14.7609 8.19922 15.2696 8.19922 15.8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.5 11C19.433 11 21 9.433 21 7.5C21 5.567 19.433 4 17.5 4C15.567 4 14 5.567 14 7.5C14 9.433 15.567 11 17.5 11Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.5 21C9.53757 21 12 18.5376 12 15.5C12 12.4624 9.53757 10 6.5 10C3.46243 10 1 12.4624 1 15.5C1 18.5376 3.46243 21 6.5 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.5 6C7.88071 6 9 4.88071 9 3.5C9 2.11929 7.88071 1 6.5 1C5.11929 1 4 2.11929 4 3.5C4 4.88071 5.11929 6 6.5 6Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconSpaAccess;